import { AbstractLogger, isSameOrHigherLevel } from './AbstractLogger';
import { sanitizeForStructuredClone } from './serialization';
/**
 * Console logger implementation for main process
 */
export class ConsoleLogger extends AbstractLogger {
    /**
     * @param {BroadcastInterface|null} broadcast If null, log will be nod broadcasted
     */
    constructor(minimumLevel, broadcast = null, broadcastKey = 'main-process-log', broadcastSource = 'main') {
        super(minimumLevel);
        this.broadcast = broadcast;
        this.broadcastKey = broadcastKey;
        this.broadcastSource = broadcastSource;
    }
    log(level, message, context) {
        if (isSameOrHigherLevel(level, this.minimumLevel)) {
            //const timestamp = new Date().toISOString();
            //const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
            if (this.broadcast || context?.['__broadcast']) {
                this.broadcastLog(level, message, context);
            }
            // Log to console in main process will result to log to stdout in terminal meaning to log to journalctl in Linux
            // Log to console (terminal)
            /*
            if (level === LogLevel.DEBUG) {
              context ? console.log(`${prefix} ${message}`, this.clearContext(context)) : console.log(`${prefix} ${message}`);
              return;
            }
      
            if ([LogLevel.INFO, LogLevel.NOTICE].indexOf(level) !== -1) {
              context ? console.info(`${prefix} ${message}`, this.clearContext(context)) : console.info(`${prefix} ${message}`);
              return;
            }
      
            if (level === LogLevel.WARNING) {
              context ? console.warn(`${prefix} ${message}`, this.clearContext(context)) : console.warn(`${prefix} ${message}`);
              return;
            }
      
            // For ERROR, CRITICAL, ALERT, EMERGENCY
            context ? console.error(`${prefix} ${message}`, this.clearContext(context)) : console.error(`${prefix} ${message}`);
            */
        }
    }
    /**
     * Set minimum log level
     */
    setMinimumLevel(level) {
        this.minimumLevel = level;
    }
    /**
     * Get current minimum log level
     */
    getMinimumLevel() {
        return this.minimumLevel;
    }
    async destroy() {
        // no action needed
    }
    async flush() {
        // no action needed
    }
    /**
     * Send log message to broadcast
     */
    broadcastLog(level, message, context) {
        try {
            const logData = {
                level,
                message,
                timestamp: new Date().toISOString().split('T')[1],
                source: this.broadcastSource,
                context: undefined,
            };
            if (context) {
                const clearContext = this.clearContext(context);
                if (clearContext && Object.keys(clearContext).length > 0) {
                    logData.context = clearContext;
                }
            }
            const safeLogData = sanitizeForStructuredClone(logData);
            if (context?.['__broadcast']) {
                context['__broadcast'].broadcast(this.broadcastKey, safeLogData);
            }
            else {
                this.broadcast?.broadcast(this.broadcastKey, safeLogData);
            }
        }
        catch (error) {
            // Silently fail to avoid infinite logging loops
            console.error('[ConsoleLogger] Failed to send log to renderer:', error);
        }
    }
}
export default ConsoleLogger;
//# sourceMappingURL=ConsoleLogger.js.map